import MultipleSelect from 'components/commons/form/MultipleSelect';
import { Dayjs } from 'dayjs';
import { handleChange } from 'feature/form/formSlice';
import { getSettlementLetters } from 'feature/settlementLetters/settlementLettersSlice';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Stack } from 'styles';
import CustomDateRangePicker from 'styles/datePicker/CustomDateRangePicker';
import { DEBOUNCE_DELAY } from 'utils/constants';

const SettlementLettersFilters = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { carriers } = useSelector((store: RootState) => store.form);
	const { loaded } = useSelector((store: RootState) => store.settlementLetters);

	const [carriersState, setCarriersState] = useState<string[]>(['All']);

	const [startDate, setStartDate] = useState<Dayjs | null>(null);
	const [endDate, setEndDate] = useState<Dayjs | null>(null);

	const [endDateError, setEndDateError] = useState<boolean>(false);

	const debounceRef = useRef<NodeJS.Timeout | null>(null);

	const onSearch = () => {
		if (debounceRef.current) {
			clearTimeout(debounceRef.current);
		}
		debounceRef.current = setTimeout(() => {
			dispatch(
				handleChange({
					name: 'inputSettlementLettersCarriers',
					value: carriersState,
				}),
			);
			dispatch(
				handleChange({
					name: 'inputSettlementLettersStartDate',
					value: startDate ? startDate.format('YYYY-MM-DD') : null,
				}),
			);
			dispatch(
				handleChange({
					name: 'inputSettlementLettersEndDate',
					value: endDate ? endDate?.format('YYYY-MM-DD') : null,
				}),
			);

			dispatch(getSettlementLetters(''));
		}, DEBOUNCE_DELAY);
	};

	const handleChangeMultipleSelect = (e: string[]) => {
		setCarriersState(e);
	};

	const checkDate = () => {
		if (startDate && !endDate) {
			setEndDateError(true);
		} else {
			setEndDateError(false);
		}
	};

	// we do not have a search button
	// so the search has to start as soon as the user changes the filters
	useEffect(() => {
		// if documents list is not ready do not do anything
		if (!loaded) {
			return;
		}

		onSearch();
		// disabled because onSearch cannot be used as a dependecy
		// otherwise will trigger every time one of the filters changes
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [carriersState, startDate, endDate]);

	useEffect(() => {
		if (startDate && endDate) {
			setEndDateError(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [endDate]);

	return (
		<Stack direction={'row'} gap={'10px'} width={'100%'}>
			<MultipleSelect
				items={carriers}
				name={'carrier'}
				value={carriersState}
				onChange={handleChangeMultipleSelect}
			/>
			<CustomDateRangePicker
				name="period"
				dates={[startDate, endDate]}
				error={endDateError}
				errorMessage="error.endDate"
				setStartDate={setStartDate}
				setEndDate={setEndDate}
				onClose={checkDate}
			/>
		</Stack>
	);
};

export default SettlementLettersFilters;
